/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the ShareMetaResponse interface.
 */
export function instanceOfShareMetaResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function ShareMetaResponseFromJSON(json) {
    return ShareMetaResponseFromJSONTyped(json, false);
}
export function ShareMetaResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : json['incidentReportType'],
        'suburb': !exists(json, 'suburb') ? undefined : json['suburb'],
        'incidentDateTime': !exists(json, 'incidentDateTime') ? undefined : (json['incidentDateTime'] === null ? null : new Date(json['incidentDateTime'])),
        'incidentTimezone': !exists(json, 'incidentTimezone') ? undefined : json['incidentTimezone'],
        'hasContentWarning': !exists(json, 'hasContentWarning') ? undefined : json['hasContentWarning'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'hasThumbnail': !exists(json, 'hasThumbnail') ? undefined : json['hasThumbnail'],
    };
}
export function ShareMetaResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'incidentReportType': value.incidentReportType,
        'suburb': value.suburb,
        'incidentDateTime': value.incidentDateTime === undefined ? undefined : (value.incidentDateTime === null ? null : value.incidentDateTime.toISOString()),
        'incidentTimezone': value.incidentTimezone,
        'hasContentWarning': value.hasContentWarning,
        'description': value.description,
        'hasThumbnail': value.hasThumbnail,
    };
}
